export const version = 1735014689136;
export default version;
